<template>
  <div class="headers">
    <ul>
      <li>
        <a href="javascript:;">{{ headersTitle }}</a>
      </li>
    </ul>
    <div class="right">
      <ul>
        <li class="one">
          <router-link target="_blank" to="/user_notice">
            <img src="@/assets/qindex1.png" />
            <span >通知</span>
            <span class="two" v-if="unreadCount == true "></span>
          </router-link>
        </li>
        <li @click="OnXia">
          <router-link to="" >
            <img src="@/assets/qindex10.png" />
            <span>帮助</span>
          </router-link>
        </li>
        <li>
          <router-link to="/user_mianshi">
            <img src="@/assets/qindex11.png" />
            <span>面试</span>
          </router-link>
        </li>
        <li>
          <router-link to="/user_collect">
            <img src="@/assets/qindex5.png" />
            <span>我的收藏</span>
          </router-link>
        </li>
        <li>
          <router-link to="/user_home">
            <img src="@/assets/qindex9.png" />
            <span>企业主页</span>
          </router-link>
        </li>
      </ul>
      <div class="user">
        <el-dropdown @command="handleCommand">
          <router-link to="/">
            <img :src="userInfo.avatar" />
            <span>{{ userInfo.nickname }}</span>
          </router-link>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="outLogin">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import{notifyMessage } from '../api/index'
export default {
  name: "navbars",
  computed: {
    headersTitle() {
      return this.$store.state.headersTitle;
    },
    userInfo() {
      return JSON.parse(this.$store.state.userInfo);
    },
    unreadCount() {
      return this.$store.state.unreadCount
    }
  },
  data() {
    return {
      // unreadCount: false, // 未读,
    };
  },
 

  methods: {
  OnXia(){
    console.log(3333)
    window.open('https://qy.changanjoin.com/军工人才网平台-操作手册(企业端)20231019.docx', ["_self"]);
  },

    handleCommand(e) {
      let that = this;
      if (e == "outLogin") {
        that.$message.success("成功退出!");
        setTimeout(() => {
          that.$router.push("/user_login");
          that.$store.dispatch("outLoginClick");
        }, 800);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.one{
  position: relative;
}
// .one::after{
//    content: '';
//     width: 5px;
//     height: 5px;
//     display: block;
//     background-color: red;
//     position: absolute;
//     top: 0;
//     left: 30px;
//     border-radius: 50px;
// }
.two{
  width: 5px;
    height: 5px;
    display: block;
    background-color: red;
    position: absolute;
    top: 20px;
    left: 50px;
    border-radius: 50px;
}

.headers {
  width: 100%;
  height: 68px;
  background: #fdfdff;
  position: fixed;
  left: 0;
  top: 0;
  padding-right: 20px;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 265px;
}

.headers .right {
  height: 100%;
  display: flex;
  align-items: center;
}

.headers .right ul {
  height: 100%;
  display: flex;
  align-items: center;
}

.headers .right ul li {
  height: 100%;
  margin-left: 24px;
}

.headers .right ul li a {
  height: 100%;
  display: flex;
  align-items: center;
}

.headers .right ul li a img {
  width: 18px;
  margin-right: 10px;
}

.headers .right ul li a span {
  font-size: 18px;
  color: #333333;
}

.headers .right .user {
  display: flex;
  align-items: center;
  margin-left: 45px;
}

.headers .right .user a {
  display: flex;
  align-items: center;
}

.headers .right .user a img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  margin-right: 6px;
}

.headers .right .user a span {
  font-size: 18px;
  color: #333333;
}

.headers > ul {
  display: flex;
  align-items: center;
}

.headers > ul li {
  height: 100%;
  margin-right: 15px;
  font-size: 16px;
}

.headers > ul li a {
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/headers1.vue